// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import $ from 'jquery'
import '@/assets/css/main.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
        /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
        ak: 'rNKGGXTxj0IQxSoty5tHUoKqYIxQKRcV'
})
Vue.use(ElementUI);
import Axios from 'axios'
Vue.prototype.Axios = Axios;
Vue.prototype.Axios.defaults.withCredentials = true;
Vue.prototype.Axios.defaults.headers = {
    'Content-Type': 'application/json',
};

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js